import backgrounds from './backgrounds.json'
import events from './events.json'
import flags from './flags.json'
import hocs from './hocs.json'
import kinematics from './kinematics.json'
import miningScreens from './miningScreens.json'
import media from './media.json'
import indicators from './indicators.json'
import popups from './popups.json'
import commonPreload from './commonPreload.json'
import preloader from './preloader.json'
import scenes from './scenes.json'
import alerts from './alerts.json'
import sceneObjects from './sceneObjects.json'
import screens from './screens.json'
import atlas from './mapAtlas.json'
import animations from './animations.json'
import sprites from './sprites.json'
import buildings from './buildings.json'
import sounds from './sounds.json'
import buildingParameters from './BuildingsParameters.json'
import meshModifications from './meshModifications.json'
import simpleModels from './simpleModels.json'
import ui from './ui.json'
import uiSets from './uiSets.json'

export default {
  atlas,
  alerts,
  animations,
  sprites,
  backgrounds: {
    ...backgrounds,
  },
  buildings,
  buildingParameters,
  commonPreload,
  events,
  flags,
  hocs,
  indicators,
  media: media,
  miningScreens,
  meshModifications,
  popups,
  preloader: preloader,
  scenes: {
    ...kinematics,
    ...scenes, // Normal scenes
  },
  sceneObjects: {
    ...sceneObjects, // Normal sceneObjects like doors and other stuff
  },
  simpleModels,
  screens,
  sounds: sounds,
  ui,
  uiSets,
}
